import { useState } from "react";
import { Phone, Send, MessageCircle, Mail } from "lucide-react";
import { Input } from "./ui/input";
import { useToast } from "../hooks/use-toast";
import { whatsappUrl } from "../mock";

export default function Contact() {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", whatsapp: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.whatsapp) {
      toast({ title: "Preencha todos os campos", description: "Precisamos de todas as informações para continuar." });
      return;
    }
    setLoading(true);

    // save lead to backend
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${BACKEND_URL}/api/leads/form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
    } catch (err) {
      // fallback: save to localStorage
      try {
        const leads = JSON.parse(localStorage.getItem("igreen_leads") || "[]");
        leads.push({ ...form, ts: new Date().toISOString() });
        localStorage.setItem("igreen_leads", JSON.stringify(leads));
      } catch (e2) {}
    }

    setTimeout(() => {
      setLoading(false);
      toast({ title: "Enviado com sucesso!", description: "Redirecionando para o WhatsApp do Rodney..." });
      const msg = encodeURIComponent(`Olá Rodney, meu nome é ${form.name}. Cheguei até você pelo site e quero ser licenciado!`);
      window.open(`https://wa.me/5547999641269?text=${msg}`, "_blank");
      setForm({ name: "", email: "", whatsapp: "" });
    }, 700);
  };

  return (
    <section id="contato" className="py-20 bg-gradient-to-b from-slate-50 to-emerald-50 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <h2 className="text-slate-900 text-3xl md:text-5xl font-extrabold leading-tight">
            Pronto para <span className="green-gradient-text">Transformar Sua Vida?</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-xl mx-auto">
            Deixe seus dados e o Rodney Espindola entrará em contato para te ajudar a dar o primeiro passo rumo à sua nova carreira.
          </p>
        </div>

        <form onSubmit={onSubmit} className="mt-10 rounded-3xl bg-white border border-slate-200 shadow-xl p-6 md:p-8 space-y-4">
          <Input
            name="name"
            value={form.name}
            onChange={onChange}
            placeholder="Seu nome completo"
            className="h-12"
          />
          <Input
            name="email"
            value={form.email}
            onChange={onChange}
            type="email"
            placeholder="Seu melhor e-mail"
            className="h-12"
          />
          <Input
            name="whatsapp"
            value={form.whatsapp}
            onChange={onChange}
            placeholder="Seu WhatsApp (com DDD)"
            className="h-12"
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl text-base disabled:opacity-70"
          >
            {loading ? "Enviando..." : (<><Send className="w-4 h-4" /> Quero Ser Licenciado</>)}
          </button>
          <p className="text-center text-slate-500 text-xs">
            Ao enviar, você será redirecionado para o WhatsApp do Rodney.
          </p>
        </form>

        <div className="mt-8 text-center">
          <p className="text-slate-600 text-sm mb-4">Ou entre em contato diretamente:</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={whatsappUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-emerald-500 text-white font-semibold hover:bg-emerald-600 transition-colors">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <a href="mailto:rodneybe@icloud.com" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors">
              <Mail className="w-4 h-4" /> Enviar Email
            </a>
            <a href="tel:+5547999641269" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-slate-300 text-slate-700 font-semibold hover:bg-white transition-colors">
              <Phone className="w-4 h-4" /> Ligar Agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
